<template>
  <card type="user">


    <div class="row">
      <div class="col-lg-3 ml-auto mr-auto">
    
         <h3>{{ companyName.toUpperCase() }}</h3>
         <h5 slot="header" class="title">Hoşgeldiniz.</h5>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Email" v-model="email">
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Password" type="password" v-model="password">
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-default btn-block" @click="signIn()">Giriş Yap</button>

          </div>
        </div>
      </div>
    </div>

  </card>
</template>
<script>
  import authorizationService from "../services/authorization.service.js";


  export default {
    data() {
      return {
        companyName: process.env.VUE_APP_COMPANY_NAME,
        email: '',
        password: '',
      }
    },
    mounted() {
    },
    created() {
      document.title = process.env.VUE_APP_COMPANY_NAME
    },
    methods: {
      signIn() {
        if (this.email && this.password) {
          authorizationService.signIn(this.email, this.password)
            .then(response => {
              setTimeout(() => this.$router.push("/admin/overview"), 300)
            }).catch(err => {
              console.log({err})
            })
        }
      }
    }
  }
</script>
<style>
</style>